module.exports = __webpack_public_path__ + "img/content3.c5aaf117.png";